export type DomainStatus = "pending" | "active" | "inactive"

export type DomainStatusInfo = {
  label: string
  variant: "success" | "danger" | "warning"
}

export function getDomainStatusInfo(status: DomainStatus): DomainStatusInfo {
  if (status === "active") {
    return {
      label: i18n.t("js.email_accounts_center.domains_table.status.active"),
      variant: "success",
    }
  }

  if (status === "inactive") {
    return {
      label: i18n.t("js.email_accounts_center.domains_table.status.inactive"),
      variant: "danger",
    }
  }

  return {
    label: i18n.t("js.email_accounts_center.domains_table.status.pending", {
      default: "Pending",
    }),
    variant: "warning",
  }
}
